import { render } from "./CorporateAIEditorModal.vue?vue&type=template&id=1f6a9c58&scoped=true&ts=true"
import script from "./CorporateAIEditorModal.vue?vue&type=script&lang=ts"
export * from "./CorporateAIEditorModal.vue?vue&type=script&lang=ts"

import "./CorporateAIEditorModal.vue?vue&type=style&index=0&id=1f6a9c58&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6a9c58"]])

export default __exports__